import { createSelector } from 'reselect';
import get from 'lodash/get';

export const savedSelector = state => state.surveys.saved;
export const referralFormsSelector = state => state.surveys.reqReferralForms;
export const formResultSelector = state => state.surveys.reqFormResult;
export const submitSurveySelector = state => state.surveys.submit;

//= =================ANSWERED SURVEY==============

export const answeredSelector = state => state.surveys.answered;
export const selectAnsweredList = createSelector(
  answeredSelector,
  state => get(state, 'list', []),
);

export const selectAnsweredListCounter = createSelector(
  answeredSelector,
  request => {
    return get(request, ['meta', 'formsCount'], 0);
  },
);

export const selectAnsweredPagination = createSelector(
  answeredSelector,
  state => get(state, 'pagination'),
);
//= ================================================
//= =================UPCOMING SURVEY PROCEED========

export const selectUpcomingSurveyProceed = state =>
  state.surveys.upcomingSurveyProceed;
export const selectUpcomingSurveyProceedPending = createSelector(
  selectUpcomingSurveyProceed,
  state => get(state, 'sending', false),
);
export const selectUpcomingSurveyProceedRejected = createSelector(
  selectUpcomingSurveyProceed,
  state => get(state, 'rejected', null),
);

//= ================================================
//= =================UPCOMING SURVEY================

export const selectUpcomingSurvey = state => state.surveys.upcomingSurvey;
export const selectUpcomingSurveyAssignmentId = createSelector(
  selectUpcomingSurvey,
  request => get(request, 'assignmentId', 0),
);

export const sendingUpcomingSurveySelector = createSelector(
  selectUpcomingSurvey,
  request => get(request, 'sending', false),
);

//= ==================================================
//= ========================UPCOMING==================

export const upcomingSelector = state => state.surveys.upcoming;
export const selectUpcomingList = createSelector(
  upcomingSelector,
  state => get(state, 'list', []),
);

export const selectUpcomingSending = createSelector(
  upcomingSelector,
  state => get(state, 'sending', false),
);

export const selectUpcomingListCounter = createSelector(
  upcomingSelector,
  request => {
    return get(request, ['meta', 'totalCount'], 0);
  },
);

export const upcomingPaginationSelector = createSelector(
  upcomingSelector,
  state => get(state, 'pagination'),
);

//= ==================================================

export const answeredListSelector = createSelector(
  answeredSelector,
  answered => get(answered, 'list', []),
);

export const selectAnsweredListSending = createSelector(
  answeredSelector,
  answered => get(answered, 'sending', false),
);

export const referralFormsListSelector = createSelector(
  referralFormsSelector,
  request => get(request, 'list', []),
);

export const loadingReferralFormsSelector = createSelector(
  referralFormsSelector,
  request => get(request, 'sending', false),
);

export const loadingFormResultSelector = createSelector(
  formResultSelector,
  request => get(request, 'sending', false),
);

export const sendingSubmitSurveySelector = createSelector(
  submitSurveySelector,
  request => get(request, 'sending', false),
);

//= =================UPCOMING SURVEY COMPLETIONS==============

export const selectUpcomingSurveyCompletions = state =>
  state.surveys.upcomingSurveyCompletions;

export const sendingUpcomingSurveyCompletionsSucceed = createSelector(
  selectUpcomingSurveyCompletions,
  request => get(request, 'succeed', false),
);



// WEBPACK FOOTER //
// ./src/redux/surveys/selectors.js